import {
  AppLanguages,
  AppRegions,
  AppRoutePaths,
  ZENDESK_CHAT_CONFIG_BY_REGIONS_AND_LANGUAGES_MAP,
} from 'app-constants';
import { region, zendeskChatKeyCode } from 'environment';
import i18n from 'i18next';
import scssVars from 'styles/export.module.scss';
import { isAppLanguage } from 'utils';
import { isAppRegion } from 'utils/isAppRegion';

const isCreditLine = `${window.location.pathname}`.includes(
  AppRoutePaths.CREDIT_LINE,
);

export const changeZendeskLocale = (locale: string): void => {
  if (!zendeskChatKeyCode) return;

  (
    window as unknown as Window & {
      zE: (widget: string, action: string, locale: string) => void;
    }
  ).zE('webWidget', 'setLocale', locale);
  setZendeskChatSettings(locale);
};

export const setZendeskChatSettings = (locale: string): void => {
  const appRegion = isAppRegion(region) ? region : AppRegions.et;
  const appLanguage = isAppLanguage(locale) ? locale : AppLanguages.en;

  const settings =
    ZENDESK_CHAT_CONFIG_BY_REGIONS_AND_LANGUAGES_MAP[appRegion][appLanguage];

  (
    window as unknown as Window & {
      zE: (
        widget: string,
        action: string,
        settings: Record<string, unknown>,
      ) => void;
    }
  ).zE('webWidget', 'updateSettings', {
    webWidget: {
      ...settings,
      color: {
        theme: isCreditLine ? '#3300ff' : scssVars.colorPrimary,
        launcher: isCreditLine ? '#3300ff' : scssVars.colorWhite,
        launcherText: isCreditLine
          ? scssVars.colorWhite
          : scssVars.colorPrimary,
      },
    },
  });
};

export const loadZendeskWidget = (locale = i18n.language): void => {
  if (!zendeskChatKeyCode) return;

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'ze-snippet';
  script.async = true;
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskChatKeyCode}`;
  script.addEventListener('load', () => {
    changeZendeskLocale(locale);
    setZendeskChatSettings(locale);
  });
  document.getElementsByTagName('body')[0].appendChild(script);
};
